<template>
  <div
    class="ScreenAdapter"
    :style="reactiveStyle"
  >
    <!-- <h1 style="color: white">{{ currentWidth }} * {{ currentHeight }}</h1> -->
    <slot />
  </div>
</template>
<script>
const Debounce = (fn, t) => {
  const delay = t || 500;
  let timer;
  return function () {
    const args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      timer = null;
      fn.apply(args);
    }, delay);
  };
};
export default {
  props: {
    width: {
      type: String,
      default: "1920",
    },
    height: {
      type: String,
      default: "1080",
    },
  },
  data() {
    return {
      transform: "scale(1) translate(-50%, -50%)",
      currentWidth: window.innerWidth,
      currentHeight: window.innerHeight,
    };
  },
  computed: {
    reactiveStyle() {
      return {
        width: this.width + "px",
        height: this.height + "px",
        transform: this.transform,
      };
    },
  },
  mounted() {
    // 获取放大缩小比例
    const getScale = () => {
      const w = window.innerWidth / this.width;
      const h = window.innerHeight / this.height;
      return w < h ? w : h;
    };
    // 设置比例
    const setScale = () => {
      this.currentWidth = window.innerWidth;
      this.currentHeight = window.innerHeight;
      this.transform = "scale(" + getScale() + ") translate(-50%, -50%)";
    };
    setScale();
    window.onresize = Debounce(setScale, 1000);
  },
};
</script>
<style scoped>
.ScreenAdapter {
  transform-origin: 0 0;
  position: absolute;
  left: 50%;
  top: 50%;
  transition: 0.3s;
}
</style>
